import BaseService from './base.service';

export default class DialingCodeService {
    static ENDPOINT = '/dialing-codes';

    static async getDialingCodes() {
        return BaseService.get(this.ENDPOINT);
    }
}
